import type { FaireProductEntity } from "../../entity_types/product";

export const p_5z8qyx7f4k: FaireProductEntity = {
  token: "p_5z8qyx7f4k",
  type: "product",
  name: "Los Angeles– Air Freshener",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/7acf0b7c8698c051fc476019465623ae610f5a69a55d7d6db3611f3d25f4f4c3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d9286928bc6c7fc14e601fe92e3f0b5c290e16824a6b21eca556985932d926ab.jpeg",
    "https://cdn.faire.com/fastly/0c5184a92011fe5b758d57627f6fac1b7f76575d185ed17314b74dc05552aee3.jpeg",
    "https://cdn.faire.com/fastly/ad558c37f5f1152adf350b1954401ab3cb16c8f2efee98a2c114d68f5bfbcb17.jpeg",
    "https://cdn.faire.com/fastly/8e672294b920374d4a0245f1970e5821b2dd94bc53c374b0e0ababc7dd4ea592.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "Like a springtime walk at dusk in the rolling hills of Los Angeles. Redwood, lime, jasmine, and yarrow.\n\nAir Fresheners are a flame-free collection designed to scent small spaces, like closets, bathrooms, gym lockers, trash cans, hotel rooms, and anywhere else that needs a little fragrance boost. \n\nThey are pre-packed in pairs, featuring an iconic P.F. Candle-shape and signature kraft paper look. Available in 8 best-selling Classic Line scents. ",
  tags: [],
  msrpDollars: 11.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:55.264Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
